var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetosDeEntrenamiento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 61,
    viewBox: "0 0 32 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.8477,
    y: 11.1289,
    width: 8.35579,
    height: 38.4366,
    transform: "rotate(-0.797092 11.8477 11.1289)",
    fill: "#9B5AE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.081543,
    y: 6.27856,
    width: 30.9164,
    height: 9.80352,
    rx: 4.90176,
    transform: "rotate(-0.797092 0.081543 6.27856)",
    fill: "#9B5AE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.34131,
    y: 0.383606,
    width: 24.2318,
    height: 5.01347,
    rx: 2.50674,
    transform: "rotate(-0.797092 3.34131 0.383606)",
    fill: "#9B5AE6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6689,
    y: 54.3073,
    width: 30.9164,
    height: 8.81967,
    rx: 4.40984,
    transform: "rotate(179.203 31.6689 54.3073)",
    fill: "#9B5AE6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4082,
    y: 60.2023,
    width: 24.2318,
    height: 5.01347,
    rx: 2.50674,
    transform: "rotate(179.203 28.4082 60.2023)",
    fill: "#9B5AE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetosDeEntrenamiento);
export default __webpack_public_path__ + "static/media/retos_de_entrenamiento.27f3f1559b1ce66e02ad70c6dfcb99b5.svg";
export { ForwardRef as ReactComponent };